export default "__VITE_ASSET__BdWzvs_o__"